import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { SidebarComponent } from 'src/app/components/sidebar/sidebar.component';
import { NotFoundComponent } from 'src/oldApp/shared/not-found/not-found.component';
import { ModalCategoryPromoterComponent } from 'src/oldApp/shared/modal-category-promoter/modal-category-promoter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalGoalRegionComponent } from 'src/oldApp/shared/modal-goal-region/modal-goal-region.component';
import { ModalGoalStateComponent } from 'src/oldApp/shared/modal-goal-state/modal-goal-state.component';
import { NgxMaskModule } from 'ngx-mask';
import { ModalEmployeeJobComponent } from 'src/oldApp/shared/modal-employee-job/modal-employee-job.component';
import { ModalPaymentFrequencyComponent } from 'src/oldApp/shared/modal-payment-frequency/modal-payment-frequency.component';
import { ModalProductCategoryComponent } from 'src/oldApp/shared/modal-product-category/modal-product-category.component';
import { ModalCollectAmountRangeComponent } from 'src/oldApp/shared/modal-collect-amount-range/modal-collect-amount-range.component';
import { ModalCommissionCalendarComponent } from 'src/oldApp/shared/modal-commission-calendar/modal-commission-calendar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalFeeEmployeeJobComponent } from 'src/oldApp/shared/modal-fee-employee-job/modal-fee-employee-job.component';
import { ModalJobPositionBiComponent } from 'src/oldApp/shared/modal-job-position-bi/modal-job-position-bi.component';
import { ModalConfirmComponent } from 'src/oldApp/shared/modal-confirm/modal-confirm.component';
import { ModalScPromoterCategoryComponent } from 'src/app/shared/modal-sc-promoter-category/modal-sc-promoter-category.component';
import { ModalScGoalEmployeeJobComponent } from 'src/oldApp/shared/modal-sc-goal-employee-job/modal-sc-goal-employee-job.component';
import { ModalScProductCategoryComponent } from 'src/oldApp/shared/modal-sc-product-category/modal-sc-product-category.component';
import { ModalScProductSharedComponent } from 'src/oldApp/shared/modal-sc-product-shared/modal-sc-product-shared.component';
import { ModalScProductDealerComponent } from 'src/oldApp/shared/modal-sc-product-dealer/modal-sc-product-dealer.component';
import { ModalScProductCollectAmountComponent } from 'src/oldApp/shared/modal-sc-product-collect-amount/modal-sc-product-collect-amount.component';
import { ModalScProductEmployeeJobComponent } from 'src/oldApp/shared/modal-sc-product-employee-job/modal-sc-product-employee-job.component';
import { MultiselectDropdownComponent } from 'src/app/shared/multiselect-dropdown/multiselect-dropdown.component';
import { PipesModule } from 'src/oldApp/pipes/pipes.module';
import { ModalVwCommissionPanelComponent } from 'src/oldApp/shared/modal-vw-commission-panel/modal-vw-commission-panel.component';
import { DataTablesModule } from 'angular-datatables';
import { ModalAlertComponent } from 'src/oldApp/shared/modal-alert/modal-alert.component';
import { ModalCommissionSalePromotionsComponent } from 'src/app/shared/modal-commission-sale-promotions/modal-commission-sale-promotions.component';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { CustomDualListboxComponent } from 'src/app/shared/custom-dual-listbox/custom-dual-listbox.component';
import { CustomDualListboxComponentV2 } from 'src/app/shared/custom-dual-listbox-v2/custom-dual-listbox-v2.component';
import { ModalConversionConfigurationComponent } from 'src/oldApp/shared/modal-conversion-configuration/modal-conversion-configuration.component';
import { ModalCommissionConfigurationComponent } from 'src/oldApp/shared/modal-commission-configuration/modal-commission-configuration.component';
import { ModalUploadBaseRefiComponent } from 'src/oldApp/shared/modal-upload-base-refi/modal-upload-base-refi.component';
import { ModalDateSelectionComponent } from 'src/oldApp/shared/modal-date-selection/modal-date-selection.component';
import { ModalCommissionPromoterAdditionalComponent } from 'src/oldApp/shared/modal-commission-promoter-additional/modal-commission-promoter-additional.component';
import { ModalUploadBaseFisofoComponent } from 'src/oldApp/shared/modal-upload-base-fisofo/modal-upload-base-fisofo.component';
import { ModalCommissionFisofoConfigurationComponent } from 'src/oldApp/shared/modal-commission-fisofo-configuration/modal-commission-fisofo-configuration.component';
import { ModalCatGoalEmployeeJobFisofoComponent } from 'src/oldApp/shared/modal-cat-goal-employee-job-fisofo/modal-cat-goal-employee-job-fisofo.component';
import { ModalAdjustCommissionComponent } from 'src/app/shared/modal-commission-adjust/modal-commission-adjust.component';
import { ModalAdditionalCommissionPromotorComponent } from 'src/oldApp/shared/modal-commission-additional-promotor/modal-commission-additional-promotor.component';
import { ModalAdditionalCommissionCreditComponent } from 'src/oldApp/shared/modal-commission-additional-credit/modal-commission-additional-credit.component';
import { ModalSchemeConfiguratorComponent } from 'src/app/shared/modal-sheme-configutator/modal-scheme-configurator.component';
import { ModalNewHybridComponent } from 'src/oldApp/shared/modal-new-hybrid/modal-new-hybrid.component';
import { ModalValidateCommissionComponent } from 'src/app/shared/modal-validate-commission/modal-validate-commission.component';
import { ModalCommissionDispositionComponent } from 'src/oldApp/shared/modal-commission-disposition/modal-commission-disposition.component';
import { ModalCommissionAdjustDispositionComponent } from 'src/oldApp/shared/modal-commission-disposition/modal-commission-adjust-disposition/modal-commission-adjust-disposition.component';
import { ReleaseNewPartnerComponent } from 'src/oldApp/shared/release-new-partner/release-new-partner.component';
import { ModalCommissionPartialComponent } from 'src/oldApp/shared/modal-commission-partial/modal-commission-partial.component';
import { ModalNewPromotionComponent } from 'src/app/shared/modal-new-promotion/modal-new-promotion.component';
import { ModalNewPromotionV2Component } from 'src/app/shared/modal-new-promotion-v2/modal-new-promotion-v2.component';
import { ModalConfigPromotionComponent } from 'src/app/shared/modal-config-promotion/modal-config-promotion.component';
import { ModalConfigPromotionV2Component } from 'src/app/shared/modal-config-promotion-v2/modal-config-promotion-v2.component';
import { MultiselectDropdownComponentV2 } from 'src/app/shared/multiselect-dropdown-v2/multiselect-dropdown-v2.component';
import { ModalCommissionHoldReleaseComponent } from './modal-commission-hold-release/modal-commission-hold-release.component';
import { ModalCommissionHoldReleaseBitComponent } from 'src/app/shared/modal-hold-release-bitacore/modal-hold-release-bitacore.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ModalMetaFormComponent } from './modal-config-promotion/meta-form-component/modal-meta-form.component';
import { MatSelectModule } from '@angular/material/select';
import { ModalMetaFormV2Component } from './modal-config-promotion-v2/meta-form-component-v2/modal-meta-form-v2.component';
import { ModalBusinessLineComponent } from 'src/app/shared/modal-business-line/modal-business-line.component';
import { ModalProductComponent } from 'src/app/shared/modal-product/modal-product.component';
import { ModalSubProductComponent } from 'src/app/shared/modal-sub-product/modal-sub-product.component';
import { ModalTermComponent } from 'src/app/shared/modal-term/modal-term.component';
import { ModalNewEmployeeJobComponent } from 'src/app/shared/modal-new-employee-job/modal-new-employee-job.component';
import { ModalNewEmployeeComponent } from 'src/app/shared/modal-new-employee/modal-new-employee.component';
import { ModalCategoryPromoterCatalogComponent } from 'src/app/shared/modal-category-promoter-catalog/modal-category-promoter-catalog.component';
import { ModalCatSaleTypeComponent } from 'src/app/shared/modal-cat-sale-type/modal-cat-sale-type.component';
import { ModalCatAgreementComponent } from 'src/app/shared/modal-cat-agreement/modal-cat-agreement.component';
import { ModalCommissionPromoterCategoryComponent } from 'src/app/shared/modal-commission-promoter-category/modal-commission-promoter-category.component';
import { ModalPromotorCategoryAssignmentComponent } from 'src/app/shared/modal-promotor-category-assignment/modal-promotor-category-assignment.component';
import { ModalCatComponentComponent } from 'src/app/shared/modal-cat-component/modal-cat-component.component';
import { ModalComponentRoleComponent } from 'src/app/shared/modal-component-role/modal-component-role.component';


@NgModule({
  entryComponents: [
    ModalCategoryPromoterComponent,
    ModalGoalRegionComponent,
    ModalGoalStateComponent,
    ModalEmployeeJobComponent,
    ModalPaymentFrequencyComponent,
    ModalProductCategoryComponent,
    ModalCollectAmountRangeComponent,
    ModalCommissionCalendarComponent,
    ModalFeeEmployeeJobComponent,
    ModalJobPositionBiComponent,
    ModalConfirmComponent,
    ModalScPromoterCategoryComponent,
    ModalScGoalEmployeeJobComponent,
    ModalScProductCategoryComponent,
    ModalScProductSharedComponent,
    ModalScProductDealerComponent,
    ModalScProductCollectAmountComponent,
    ModalScProductEmployeeJobComponent,
    MultiselectDropdownComponent,
    MultiselectDropdownComponentV2,
    ModalVwCommissionPanelComponent,
    ModalAlertComponent,
    ModalCommissionSalePromotionsComponent,
    ModalConversionConfigurationComponent,
    ModalCommissionConfigurationComponent,
    ModalUploadBaseRefiComponent,
    ModalDateSelectionComponent,
    ModalCommissionPromoterAdditionalComponent,
    ModalCommissionFisofoConfigurationComponent,
    ModalCatGoalEmployeeJobFisofoComponent,
    ModalAdjustCommissionComponent,
    ModalAdditionalCommissionPromotorComponent,
    ModalAdditionalCommissionCreditComponent,
    ModalSchemeConfiguratorComponent,
    ModalConfigPromotionComponent,
    ModalConfigPromotionV2Component,
    ModalNewHybridComponent,
    ModalNewPromotionComponent,
    ModalNewPromotionV2Component,
    ModalValidateCommissionComponent,
    ModalCommissionDispositionComponent,
    ModalCommissionAdjustDispositionComponent,
    ReleaseNewPartnerComponent,
    ModalCommissionPartialComponent,
    ModalCommissionHoldReleaseComponent,
    ModalCommissionHoldReleaseBitComponent,
    ModalMetaFormComponent,
    ModalMetaFormV2Component,
    ModalBusinessLineComponent,
    ModalProductComponent,
    ModalSubProductComponent,
    ModalTermComponent,
    ModalNewEmployeeJobComponent,
    ModalNewEmployeeComponent,
    ModalCategoryPromoterCatalogComponent,
    ModalCatSaleTypeComponent,
    ModalCatAgreementComponent,
    ModalCommissionPromoterCategoryComponent,
    ModalPromotorCategoryAssignmentComponent,
    ModalCatComponentComponent,
    ModalComponentRoleComponent
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    NotFoundComponent,
    ModalCategoryPromoterComponent,
    ModalGoalRegionComponent,
    ModalGoalStateComponent,
    ModalEmployeeJobComponent,
    ModalPaymentFrequencyComponent,
    ModalProductCategoryComponent,
    ModalCollectAmountRangeComponent,
    ModalCommissionCalendarComponent,
    ModalFeeEmployeeJobComponent,
    ModalJobPositionBiComponent,
    ModalConfirmComponent,
    ModalScPromoterCategoryComponent,
    ModalScGoalEmployeeJobComponent,
    ModalScProductCategoryComponent,
    ModalScProductSharedComponent,
    ModalScProductDealerComponent,
    ModalScProductCollectAmountComponent,
    ModalScProductEmployeeJobComponent,
    MultiselectDropdownComponent,
    MultiselectDropdownComponentV2,
    ModalVwCommissionPanelComponent,
    ModalAlertComponent,
    ModalCommissionSalePromotionsComponent,
    CustomDualListboxComponent,
    CustomDualListboxComponentV2,
    ModalConversionConfigurationComponent,
    ModalCommissionConfigurationComponent,
    ModalUploadBaseRefiComponent,
    ModalDateSelectionComponent,
    ModalCommissionPromoterAdditionalComponent,
    ModalUploadBaseFisofoComponent,
    ModalCommissionFisofoConfigurationComponent,
    ModalCatGoalEmployeeJobFisofoComponent,
    ModalAdjustCommissionComponent,
    ModalAdditionalCommissionPromotorComponent,
    ModalAdditionalCommissionCreditComponent,
    ModalSchemeConfiguratorComponent,
    ModalConfigPromotionComponent,
    ModalConfigPromotionV2Component,
    ModalNewHybridComponent,
    ModalNewPromotionComponent,
    ModalNewPromotionV2Component,
    ModalValidateCommissionComponent,
    ModalCommissionDispositionComponent,
    ModalCommissionAdjustDispositionComponent,
    ReleaseNewPartnerComponent,
    ModalCommissionPartialComponent,
    ModalNewPromotionComponent,
    ModalNewPromotionV2Component,
    ModalConfigPromotionComponent,
    ModalCommissionHoldReleaseComponent,
    ModalCommissionHoldReleaseBitComponent,
    ModalMetaFormComponent,
    ModalMetaFormV2Component,
    ModalBusinessLineComponent,
    ModalProductComponent,
    ModalSubProductComponent,
    ModalTermComponent,
    ModalNewEmployeeJobComponent,
    ModalNewEmployeeComponent,
    ModalCategoryPromoterCatalogComponent,
    ModalCatSaleTypeComponent,
    ModalCatAgreementComponent,
    ModalCommissionPromoterCategoryComponent,
    ModalPromotorCategoryAssignmentComponent,
    ModalCatComponentComponent,
    ModalComponentRoleComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    PipesModule,
    DataTablesModule,
    AngularDualListBoxModule,
    MatProgressSpinnerModule,  // ← mat-spinner
    MatIconModule,             // ← mat-icon
    MatCardModule,             // ← mat-card
    MatFormFieldModule,        // ← mat-form-field
    MatInputModule,            // ← matInput
    MatButtonModule,           // ← mat-button
    MatRadioModule,            // ← mat-radio-button
    MatSliderModule,           // ← mat-slider
    MatSlideToggleModule,      // ← mat-slide-toggle
    MatChipsModule,            // ← mat-chip
    MatTooltipModule,          // ← matTooltip
    MatDividerModule,          // ← mat-divider
    MatSelectModule,
    MatAutocompleteModule
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    NotFoundComponent,
    ModalCategoryPromoterComponent,
    ModalGoalRegionComponent,
    ModalGoalStateComponent,
    ModalEmployeeJobComponent,
    ModalPaymentFrequencyComponent,
    ModalProductCategoryComponent,
    ModalCollectAmountRangeComponent,
    ModalCommissionCalendarComponent,
    ModalFeeEmployeeJobComponent,
    ModalJobPositionBiComponent,
    ModalConfirmComponent,
    ModalScPromoterCategoryComponent,
    ModalScGoalEmployeeJobComponent,
    ModalScProductCategoryComponent,
    ModalScProductSharedComponent,
    ModalScProductDealerComponent,
    ModalScProductCollectAmountComponent,
    ModalScProductEmployeeJobComponent,
    MultiselectDropdownComponent,
    MultiselectDropdownComponentV2,
    ModalVwCommissionPanelComponent,
    ModalConversionConfigurationComponent,
    ModalAlertComponent,
    CustomDualListboxComponent,
    CustomDualListboxComponentV2,
    ModalCommissionConfigurationComponent,
    ModalUploadBaseRefiComponent,
    ModalDateSelectionComponent,
    ModalAdjustCommissionComponent,
    ModalAdditionalCommissionPromotorComponent,
    ModalAdditionalCommissionCreditComponent,
    ModalSchemeConfiguratorComponent,
    ModalConfigPromotionComponent,
    ModalConfigPromotionV2Component,
    ModalNewHybridComponent,
    ModalNewPromotionComponent,
    ModalNewPromotionV2Component,
    ModalValidateCommissionComponent,
    ModalCommissionPartialComponent,
    ModalCommissionHoldReleaseComponent,
    ModalMetaFormV2Component,
    ModalBusinessLineComponent,
    ModalProductComponent,
    ModalSubProductComponent,
    ModalTermComponent,
    ModalNewEmployeeJobComponent,
    ModalNewEmployeeComponent,
    ModalCategoryPromoterCatalogComponent,
    ModalCatSaleTypeComponent,
    ModalCatAgreementComponent,
  ],
})
export class SharedModule {}
